export const SHOW_NAV='SHOW_NAV';
export const SHOW_CARE_BAR='SHOW_CARE_BAR';
export const USER_INFO='USER_INFO';
export const NAV_SELECTED='NAV_SELECTED';

export const types = {
    [SHOW_NAV]:"showNav",
    [NAV_SELECTED]:"navSelected",
    [USER_INFO]:"userInfo",
	[SHOW_CARE_BAR]:'ShowCareBar'
}